<template>
  <div class="header">
    <div class="header__inner">

      <!-- ── MOBILE BAR (≤639px only) ────────────────────────────────────────── -->
      <div class="header__mobile">
        <!-- Hamburger → toggles stats panel below header on mobile -->
        <!-- <button class="header__mob-btn" @click="activeMobile = activeMobile === 'stats' ? '' : 'stats'" aria-label="Menu">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <rect x="3" y="5"  width="18" height="2" rx="1" fill="currentColor"/>
            <rect x="3" y="11" width="18" height="2" rx="1" fill="currentColor"/>
            <rect x="3" y="17" width="18" height="2" rx="1" fill="currentColor"/>
          </svg>
        </button> -->

        <!-- Centre: brand logo -->
        <div class="header__mob-logo" @click="$router.push('/')">
          <DougJonesMainLogo :isDark="isDarkMode" class="header__mob-logo-img" />
        </div>
        <!-- Right: profile name + logout trigger -->
        <div class="header__mob-actions" v-if="isUserAuth" ref="mobProfileWrapRef">

        <button class="header__mob-btn" @click="activeMobile = activeMobile === 'stats' ? '' : 'stats'" aria-label="Menu">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
              <path d="M12 16v-4M12 8h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </button>
          <div class="header__mob-profile" @click="dropdownOpen = !dropdownOpen">
            <span class="header__mob-name">{{ loggedInUsername }}</span>
            <BaseAvatarNew
              :storage-id="userdata?.avatarFile?.storageId"
              classes="header-avatar"
              :rating="userdata?.rating"
            />
            <svg class="profile-trigger__chevron" :class="{ 'profile-trigger__chevron--open': dropdownOpen }" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2 4L6 8L10 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <Transition name="dropdown-fade">
            <div class="profile-dropdown" v-if="dropdownOpen">
              <button class="profile-dropdown__item profile-dropdown__item--logout" @click="handleLogout" :disabled="loggingOut">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <polyline points="16 17 21 12 16 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <line x1="21" y1="12" x2="9" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span>{{ loggingOut ? 'Logging out…' : 'Logout' }}</span>
              </button>
            </div>
          </Transition>
        </div>
      </div>

      <!-- Stats panel: slides down below mobile header -->
      <transition name="header-slide">
        <div v-if="activeMobile === 'stats' && isUserAuth" class="header__mob-panel sm:hidden">
          <div class="header__page-info">
            <h1 class="header__page-title">Admin</h1>
            <div class="header__stats" v-if="statsReady && activeTab === 0">
              <div class="stat-box stat-box--pending">
                <span class="stat-box__count">{{ pendingCount }}</span>
                <span class="stat-box__label">PENDING</span>
              </div>
              <div class="stat-box stat-box--approved">
                <span class="stat-box__count">{{ approvedCount }}</span>
                <span class="stat-box__label">REMOVED</span>
              </div>
            </div>
             <div class="header__stats" v-if="statsReady && activeTab === 2">
              <div class="stat-box stat-box--referral" title="Active Referral Codes">
                <span class="stat-box__count text-[#049A8C]">{{ referralStats.activeCodes }}</span>
                <span class="stat-box__label text-[var(--text-color-white-black)] font-bold">ACTIVE<br/>CODES</span>
              </div>
              <div class="stat-box stat-box--referral" title="Inactive Referral Codes">
                <span class="stat-box__count text-[rgba(27, 31, 38, 0.72)]">{{ referralStats.inactiveCodes }}</span>
                <span class="stat-box__label text-[var(--text-color-white-black)] font-bold">INACTIVE<br/>CODES</span>
              </div>
              <div class="stat-box stat-box--referral" title="Invites Sent">
                <span class="stat-box__count text-[#007AFF]">{{ referralStats.invitesSent }}</span>
                <span class="stat-box__label text-[var(--text-color-white-black)] font-bold">INVITES<br/>SENT</span>
              </div>
              <div class="stat-box stat-box--referral" title="Registered Users">
                <span class="stat-box__count text-[#AF52DE]">{{ referralStats.regUsers }}</span>
                <span class="stat-box__label text-[var(--text-color-white-black)] font-bold">REG.<br/>USERS</span>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <!-- ── END MOBILE BAR ───────────────────────────────────────────────────── -->

      <!-- Logo — left side -->
      <div class="header__logo w-[250px]">
        <DougJonesMainLogo :isDark="isDarkMode" class="w-[130px]" />
      </div>

      <div class="header__page-info" v-if="isUserAuth">
        <h1 class="header__page-title">Admin</h1>
        <span class="header__connections-sep" v-if="activeTab != 1 && activeTab != 3">|</span>
        <!-- Stats boxes: Pending / Approved / Rejected -->
        <div class="header__stats" v-if="statsReady">

          <!-- TAB 0 & 1: existing Pending + Approved — unchanged -->
          <template v-if="activeTab == 0">
            <div
              class="stat-box stat-box--pending"
              :class="{ 'stat-box--active': activeFilter === 'pending' }"
              @click="setFilter('pending')"
              title="Filter by Pending"
            >
              <span class="stat-box__count">{{ pendingCount }}</span>
              <span class="stat-box__label text-[var(--text-color-white-black)] font-bold">PENDING</span>
            </div>
            <div
              class="stat-box stat-box--approved"
              :class="{ 'stat-box--active': activeFilter === 'approved' }"
              @click="setFilter('approved')"
              title="Filter by Approved"
            >
              <span class="stat-box__count">{{ approvedCount }}</span>
              <span class="stat-box__label text-[var(--text-color-white-black)] font-bold">REMOVED</span>
            </div>
          </template>

          <!-- TAB 2: Active Codes / Inactive Codes / Invites Sent / Reg. Users -->
          <template v-else-if="activeTab == 2">
            <div class="stat-box stat-box--referral" title="Active Referral Codes">
              <span class="stat-box__count text-[#049A8C]">{{ referralStats.activeCodes }}</span>
              <span class="stat-box__label text-[var(--text-color-white-black)] font-bold">ACTIVE<br/>CODES</span>
            </div>
            <div class="stat-box stat-box--referral" title="Inactive Referral Codes">
              <span class="stat-box__count text-[rgba(27, 31, 38, 0.72)]">{{ referralStats.inactiveCodes }}</span>
              <span class="stat-box__label text-[var(--text-color-white-black)] font-bold">INACTIVE<br/>CODES</span>
            </div>
            <div class="stat-box stat-box--referral" title="Invites Sent">
              <span class="stat-box__count text-[#007AFF]">{{ referralStats.invitesSent }}</span>
              <span class="stat-box__label text-[var(--text-color-white-black)] font-bold">INVITES<br/>SENT</span>
            </div>
            <div class="stat-box stat-box--referral" title="Registered Users">
              <span class="stat-box__count text-[#AF52DE]">{{ referralStats.regUsers }}</span>
              <span class="stat-box__label text-[var(--text-color-white-black)] font-bold">REG.<br/>USERS</span>
            </div>
          </template>

        </div>

        <!-- Loading skeleton while stats fetch -->
        <div class="header__stats" v-else>
          <div class="stat-box stat-box--skeleton" v-for="i in (activeTab === 2 ? 4 : 3)" :key="i">
            <span class="stat-box__count skeleton-line"></span>
            <span class="stat-box__label skeleton-line-sm"></span>
          </div>
        </div>
      </div>

      <div class="header__page-info" v-else>
        <h1 class="header__page-title">Community</h1>
      </div>

      <!-- Right section: username + avatar + dropdown -->
      <div class="header__right flex items-center gap-3" v-if="isUserAuth" ref="profileWrapRef">
        <div class="profile-trigger" @click="dropdownOpen = !dropdownOpen">
          <div class="profile-trigger__text">
            <span class="profile-trigger__name">{{ loggedInUsername }}</span>
          </div>
          <BaseAvatarNew
            :storage-id="userdata?.avatarFile?.storageId"
            classes="header-avatar"
            :rating="userdata?.rating"
          />
          <svg class="profile-trigger__chevron" :class="{ 'profile-trigger__chevron--open': dropdownOpen }" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 4L6 8L10 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>

        <Transition name="dropdown-fade">
          <div class="profile-dropdown" v-if="dropdownOpen">
            <button class="profile-dropdown__item profile-dropdown__item--logout" @click="handleLogout" :disabled="loggingOut">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <polyline points="16 17 21 12 16 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <line x1="21" y1="12" x2="9" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>{{ loggingOut ? 'Logging out…' : 'Logout' }}</span>
            </button>
          </div>
        </Transition>
      </div>

    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import DougJonesMainLogo from "@/components/Icons/DougJonesMainLogo.vue";
import { useSchemeObserver } from "@/utils/colorSchemeUtils";
import BaseAvatarNew from "@/components/ui-kit/BaseAvatarNew/index.vue";

const store = useStore();
const route = useRoute();
const currentScheme = useSchemeObserver();
const isDarkMode = computed(() => currentScheme.value === 'dark');

const userdata = computed(() => store.getters.getUser);
const isUserAuth = computed(() => store.getters.getAuthStatus);

// ── Active tab — driven by event from PostManagement (instant, no lag) ─────────
const activeTab = ref(
  route.query.tab === 'group'  ? 1
  : route.query.tab === 'invite' ? 2
  : route.query.tab === 'users'  ? 3
  : 0
);

function onTabChange(e: Event) {
  activeTab.value = (e as CustomEvent<{ tab: number }>).detail.tab;
}

const pendingCount     = ref(0);
const approvedCount    = ref(0);
const rejectedCount    = ref(0);
const statsReady       = ref(true);

// Prefer the display name returned by the post-stats API when tab 0 has loaded;
// fall back to firstName + lastName from the auth store so it's always visible on any tab.
const apiUsername      = ref('');
const loggedInUsername = computed(() => {
  if (apiUsername.value) return apiUsername.value;
  const u = userdata.value;
  if (u?.firstName || u?.lastName) return `${u.firstName || ''} ${u.lastName || ''}`.trim();
  return u?.username || '';
});

// ── Tab 3 referral stat counters ─────────────────────────────────────────────
const referralStats = ref({
  activeCodes:   0,
  inactiveCodes: 0,
  invitesSent:   0,
  regUsers:      0,
});

const dropdownOpen    = ref(false);
const loggingOut      = ref(false);
const profileWrapRef  = ref<HTMLElement | null>(null);
const mobProfileWrapRef = ref<HTMLElement | null>(null);
const activeMobile    = ref('');

async function handleLogout() {
  loggingOut.value = true;
  await store.dispatch('logOut');
  loggingOut.value = false;
}

function onClickOutside(e: MouseEvent) {
  const insideDesktop = profileWrapRef.value?.contains(e.target as Node) ?? false;
  const insideMobile  = mobProfileWrapRef.value?.contains(e.target as Node) ?? false;
  if (!insideDesktop && !insideMobile) {
    dropdownOpen.value = false;
  }
}

const emit = defineEmits<{
  (e: 'filter-change', status: string | null): void
}>();

const activeFilter = ref<string | null>(null);

function setFilter(status: string) {
  if (activeFilter.value === status) {
    activeFilter.value = null;
    emit('filter-change', null);
  } else {
    activeFilter.value = status;
    emit('filter-change', status);
  }
}

function onPostStats(e: Event) {
  const d = (e as CustomEvent<{ pending: number; approved: number; rejected: number; username: string }>).detail;
  pendingCount.value  = d.pending;
  approvedCount.value = d.approved;
  rejectedCount.value = d.rejected;
  if (d.username) apiUsername.value = d.username;
  statsReady.value    = true;
}

// ── NEW: listen for tab-3 referral stats dispatched by PostManagement ─────────
function onReferralStats(e: Event) {
  const d = (e as CustomEvent<{
    activeCodes: number;
    inactiveCodes: number;
    invitesSent: number;
    regUsers: number;
  }>).detail;
  referralStats.value = { ...d };
  statsReady.value = true;
}

onMounted(() => {
  window.addEventListener('post-stats',     onPostStats);
  window.addEventListener('referral-stats', onReferralStats);
  window.addEventListener('tab-change',     onTabChange);
  document.addEventListener('click', onClickOutside);
  // Fallback: show boxes even if no event fires within 1s
  setTimeout(() => { statsReady.value = true; }, 1000);
});

onUnmounted(() => {
  window.removeEventListener('post-stats',     onPostStats);
  window.removeEventListener('referral-stats', onReferralStats);
  window.removeEventListener('tab-change',     onTabChange);
  document.removeEventListener('click', onClickOutside);
});
</script>

<style lang="scss" scoped>
.header {
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 80px;
  max-height: var(--header-height);
  z-index: 1200;
  background: var(--theme-wise-background-new);
  border-bottom: 1px solid var(--header-border-light-new);
  color: var(--foreground-primary);
  flex-shrink: 0;

  &__inner {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 16px;
  }

  &__logo {
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }

  &__page-info {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
    min-width: 0;
  }

  &__page-title {
    font-size: 1.35rem;
    font-weight: 700;
    color: var(--quick-link-icon-bg);
    white-space: nowrap;
    margin: 0;
    line-height: 1;
  }

  &__stats {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: nowrap;
  }

  &__right {
    margin-left: auto;
    flex-shrink: 0;
    position: relative;
  }
}

// ── Stat boxes ──────────────────────────────────────────────────────────────
.stat-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 72px;
  padding: 6px 14px;
  border-radius: 8px;
  border: 1.5px solid transparent;
  // cursor: pointer;
  transition: background 0.18s ease, border-color 0.18s ease, transform 0.12s ease;
  user-select: none;

  // &:hover {
  //   transform: translateY(-1px);
  // }

  &__count {
    font-size: 18px;
    font-weight: 700;
    line-height: 1.1;
  }

  &__label {
    font-size: 10px;
    // font-weight: 600;
    letter-spacing: 0.8px;
    // opacity: 0.8;
    margin-top: 2px;
  }

  // Pending — amber/orange
  &--pending {
    border-color: var(--border-leftbar-component);
    color: #E7000B;
    background: var(--header-bg-light-new);

    // &:hover,
    // &.stat-box--active {
    //   background: var(--header-bg-light-new);
    //   border-color: var(--border-leftbar-component);
    // }
  }

  // Approved — teal/green
  &--approved {
    border-color: var(--border-leftbar-component);
    color: #049A8C;
    background: var(--header-bg-light-new);

    // &:hover,
    // &.stat-box--active {
    //   background: var(--header-bg-light-new);
    //   border-color: var(--border-leftbar-component);
    // }
  }

  // Rejected — red
  &--rejected {
    border-color: var(--border-leftbar-component);
    color: #FB2C36;
    background: var(--header-bg-light-new);

    // &:hover,
    // &.stat-box--active {
    //   background: var(--header-bg-light-new);
    //   border-color: var(--border-leftbar-component);
    // }
  }

  // Loading skeleton
  &--skeleton {
    border-color: var(--header-border-light-new, rgba(0,0,0,0.1));
    cursor: default;
    pointer-events: none;
    gap: 4px;

    .skeleton-line {
      display: block;
      width: 32px;
      height: 18px;
      border-radius: 4px;
      background: linear-gradient(90deg, rgba(0,0,0,0.06) 25%, rgba(0,0,0,0.1) 50%, rgba(0,0,0,0.06) 75%);
      background-size: 200% 100%;
      animation: shimmer 1.4s infinite;
    }

    .skeleton-line-sm {
      display: block;
      width: 44px;
      height: 8px;
      border-radius: 4px;
      background: linear-gradient(90deg, rgba(0,0,0,0.06) 25%, rgba(0,0,0,0.1) 50%, rgba(0,0,0,0.06) 75%);
      background-size: 200% 100%;
      animation: shimmer 1.4s infinite 0.2s;
    }
  }

  // ── NEW: Tab 3 referral stat boxes ──────────────────────────────────────────
  &--referral {
    border-color: var(--border-leftbar-component);
    color: #E7000B;
    background: var(--header-bg-light-new);
    text-align: center;
    // min-width: 64px;
    // cursor: default;

    // .stat-box__count { color: #fff; }
    // .stat-box__label {
    //   color: #fff;
    //   text-align: center;
    //   line-height: 1.3;
    // }

    // &:hover { transform: translateY(-1px); opacity: 0.92; }
  }
}

@keyframes shimmer {
  0%   { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

// ── Profile trigger ──────────────────────────────────────────────────────────
.profile-trigger {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  user-select: none;

  &__text {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    min-width: 0;
  }

  &__name {
    font-size: 13px;
    color: var(--foreground-primary);
    white-space: nowrap;
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__chevron {
    color: var(--foreground-primary);
    transition: transform 0.2s ease;
    flex-shrink: 0;

    &--open {
      transform: rotate(180deg);
    }
  }
}

// ── Profile dropdown ─────────────────────────────────────────────────────────
.profile-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  min-width: 140px;
  background: var(--quick-link-icon-bg, #049A8C);
  border: none;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
  z-index: 1300;
  overflow: hidden;

  &__item {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    padding: 10px 16px;
    background: none;
    border: none;
    cursor: pointer;
    font-size: 13px;
    color: var(--text-color-black-white);
    text-align: left;
    transition: background 0.15s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.15);
    }

    &--logout {
    color: var(--text-color-black-white);

      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
    }
  }
}

.dropdown-fade-enter-active,
.dropdown-fade-leave-active {
  transition: opacity 0.15s ease, transform 0.15s ease;
}
.dropdown-fade-enter-from,
.dropdown-fade-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

// ── Mobile bar (hidden on desktop) ──────────────────────────────────────────
.header__mobile {
  display: none;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  height: 56px;
  width: 100%;
  gap: 8px;

  @media (max-width: 639px) {
    display: flex;
  }
}

.header__mob-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: transparent;
  border: none;
  cursor: pointer;
  color: var(--foreground-primary);
  flex-shrink: 0;
  transition: background 0.15s;
  &:hover {
    background: var(--quick-link-icon-bg);
    border-color: var(--quick-link-icon-bg);
    color: var(--text-color-black-white);
  }
}

.header__mob-logo {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.header__mob-logo-img {
  height: 28px;
  width: auto;
}

.header__mob-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: auto;
  position: relative;
}

.header__mob-profile {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
}

.header__mob-name {
  font-size: 13px;
  font-weight: 500;
  color: var(--foreground-primary);
  white-space: nowrap;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header__mob-panel {
  position: fixed;
  top: 56px;
  left: 0;
  right: 0;
  z-index: 1200;
  width: 100%;
  padding: 12px 16px 14px;
  background: var(--header-bg-light-new);
  border-top: 1px solid var(--button-border-color);
  border-bottom: 1px solid var(--button-border-color);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);

  .header__page-info {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
}

.header-slide-enter-active,
.header-slide-leave-active {
  transition: transform 0.22s ease, opacity 0.18s ease;
}
.header-slide-enter-from,
.header-slide-leave-to {
  transform: translateY(-8px);
  opacity: 0;
}

// ── Responsive ──────────────────────────────────────────────────────────────
@media (max-width: 1024px) {
  .header__page-title {
    width: 100% !important;
    text-align: start !important;
  }
}

// Hide desktop sections and shrink header height on mobile
@media (max-width: 639px) {
  .header {
    height: 56px;
    padding: 0;
  }

  .header__inner > .header__logo,
  .header__inner > .header__page-info,
  .header__inner > .header__right {
    display: none;
  }
}

@media (max-width: 640px) {
  .stat-box {
    min-width: 56px;
    padding: 5px 8px;

    &__count { font-size: 14px; }
    &__label { font-size: 8px; }
  }

  .header__page-title {
    font-size: 1.1rem;
  }
}
</style>

<style lang="scss">
.header-avatar .avatar,
.header-avatar .avatar-ring {
  width: 36px !important;
  height: 36px !important;
  border-radius: 50% !important;
}
.header-avatar .avatar-img {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
  border-radius: 50% !important;
}
</style>